// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store/store'
import {store2} from './store/store2'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import imageConversion from 'image-conversion'
import pako from 'pako'
import * as echarts from 'echarts'
// 引入提示框组件、标题组件、工具箱组件。
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/grid'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/radar'
import EVueContextmenu from 'e-vue-contextmenu'
// mqtt
import * as index from './mq/index'
import validate from './utils/validate'
import commonType from './common/commonType'
import util from './utils/util'
import getImgArr from './common/getImgArr'
import routejs from './common/routejs'
import {getToken} from './utils/auth'
import excel from './utils/excel'
import fixZoom from '../static/js/fix-zoom'

import highcharts from 'highcharts'
import highcharts3d from 'highcharts/highcharts-3d'

highcharts3d(highcharts)

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(EVueContextmenu)
Vue.use(fixZoom)
Vue.prototype.store2 = store2
Vue.prototype.$echarts = echarts
Vue.prototype.validate = validate
Vue.prototype.commonType = commonType
Vue.prototype.util = util
Vue.prototype.getImgArr = getImgArr
Vue.prototype.routejs = routejs
Vue.prototype.exceljs = excel
Vue.prototype.startSub = index.startSub
Vue.prototype.sendSub = index.sendSub
Vue.prototype.closeSub = index.closeSub
Vue.prototype.imageConversion = imageConversion
Vue.prototype.$pako = pako
// eslint-disable-next-line no-extend-native
Array.prototype.indexOf = function (val) {
  for (let i = 0; i < this.length; i++) {
    if (this[i] === val) return i
  }
  return -1
}
// eslint-disable-next-line no-extend-native
Array.prototype.remove = function (val) {
  let index = this.indexOf(val)
  if (index > -1) {
    this.splice(index, 1)
  }
}
Vue.prototype.clone = function (obj) {
  let copy = (obj instanceof Array) ? [] : {}
  for (let attr in obj) {
    if (!obj.hasOwnProperty(attr)) continue
    copy[attr] = (typeof obj[attr] === 'object') ? this.clone(obj[attr]) : obj[attr]
  }
  return copy
}

Vue.prototype.golobleObject = {
  zoom: util.getZoom(),
  // 客服坐席
  getCsdSip () {},
  // 报警声
  getAudioPlay () {},
  // 运营看板
  getAlarmMarker () {},
  kindAlarmLine () {},
  sendWeather () {},
  monitorAlarm () {},
  getGoCheck () {},
  // 事件处理
  updateTableAlarm () {},
  getHandleInfo () {},
  getCallInfo () {},
  // 新頁面报警处理三框
  getNewAlarm () {},
  getMqttNewData () {},
  getMqttAddCnt () {},
  // 服务商处理订单
  updateTableOrder () {},
  getDoneOder () {},
  // 组织管理
  updateTableOrg () {},
  // 家庭、机构管理
  updateTableHome () {},
  // 服务对象管理
  updateTableSerObj () {},
  addHomeid () {},
  // 平台人员管理
  updateTableUser () {},
  addAccUser () {},
  // 登录账号管理
  updateTableAcc () {},
  // sip电话管理
  updateTableSIP () {},
  // 项目管理
  updateTablePro () {},
  // 服务频率管理
  updateTableFre () {},
  // 设备管理
  updateTableDevice () {},
  // 服务商接单
  updateTableSupp () {},
  // 服务商人员管理
  updateTableSuser () {},
  // 家庭位置添加
  setMapLngLat () {},
  // 小区/机构
  updateTableCommunity () {},
  sendIsAdd () {},
  sendIsAdd1 () {},
  // sip电话全局（拨打，结束，通话中,通话中计时，接听, 键盘拨打）
  sendCallPhone () {},
  sendEndPhone () {},
  sendCalling () {},
  sendCallTime () {},
  sendAcceptCall () {},
  sendKeyboard () {},
  // 客服关爱
  updateTableC () {},
  childSend () {},
  childMapSend () {},
  // 添加子机
  addSubNew () {},
  // 联系人
  updateFamilyNew () {},
  // 事件/服务统计
  searchOldPerson () {},
  // 电话呼入
  phoneInCall () {},
  openPhoneCall () {},
  // 处理事件完移除地图
  clearMapMaker () {},
  // 转让订单
  updateAlarmById () {},
  // 更新电话记录
  updatePhone () {},
  // 历史轨迹
  sendIsStart () {},
  // mqtt群聊刷新
  mqttChat () {},
  // mqtt即构视频
  mqttVideoCall () {},
  mattVideoCallPage () {},
  // 首页作息更新
  getChangeKefu () {},
  // 菜单点击切换
  getChangeMenu () {},
  getChangeTab () {},
  getChangeLevel2 () {},
  // 获取位置
  getSiteLocation () {},
  // 地图加载完成
  initMapCompleted () {},
  markerEvent () {},
  mapClickEvent () {},
  // 费用管理
  changeMoney () {}
}

/* eslint-disable no-new */
window.vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    // console.log(123, getToken())
    if (this.$route.path === '/') {
      this.closeSub()
    } else {
      if (getToken()) {
        this.startSub(this, getToken())
        window.setInterval(() => {
          // eslint-disable-next-line no-extend-native
          Date.prototype.format = this.validate.format
          let format = new Date().format('hh:mm:ss')
          if (format === '00:00:01') {
            const day = new Date().format('dd')
            let number = day.split('')
            let arr = [1, 3, 5, 7, 9]
            if (arr.indexOf(parseInt(number[1])) > -1) {
              store.commit('set_evenNumber', false)
            } else {
              store.commit('set_evenNumber', true)
            }
            location.reload()
          }
        }, 1000)
      }
    }
  },
  beforeDestroy () {
    this.closeSub()
  }
})



// WEBPACK FOOTER //
// ./src/main.js